import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MonitoringService } from "../../shared/services";

@Component({
  templateUrl: "./usersMonitoringDetails.component.html",
  styleUrls: ["./usersMonitoringDetails.component.css"],
})
export class UsersMonitoringDetailsComponent {
  serviceName: string = "";

  cardData: object = null;

  iconMapping = {
    "activeIOSUser": "phone_iphone",
    "activeWebUser": "language",
    "inactiveUsers": "hotel",
    "totalUsers": "group",
    "usersNotLoggedInRecently": "person_off"
  }

  constructor(
    private _monitoringService: MonitoringService,
    private _activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.serviceName = this._activatedRoute.snapshot.queryParams["name"];
    this._monitoringService
      .getVisitorDetails(this.serviceName)
      .subscribe((data) => {
        this.cardData = data;
      });
  }
  goToUserList(key: string) {
    this.router.navigate([`user-list`], {
      queryParams: { name: this.serviceName, key: key },
    });
  }
}